<template>
    <a href="#" class="btn btn_lg btn_fav btn_icontext">
        <i class="f7-icons icon_lg">heart_circle</i>
            {{ count }}
        </a>
</template>

<script>
    export default {
        data: function () {
            return {
                count: 1,
            }
        },
    }
</script>
